export const containsOnlyNumbers = (value: string): boolean => {
  return /^\d+$/.test(value)
}
